import { call, put, select } from 'redux-saga/effects';
import { IDataSourceInfo } from '../../../ts/models/IDataSourceInfo';
import { DataSources } from '../../../content/resources/Datasources';
import { setNlpSetting } from '../../actions/SetNlpSettingAction';
import { UpdateNlpSettingAction } from '../../actions/UpdateNlpSettingAction';
import { updateNlpSettingSucceeded } from '../../actions/UpdateNlpSettingSucceeded';
import { selectSpaceInfoItem } from '../../selectors/SpaceInfoSelectors';
import { AppState } from '../../state/AppState';

export function* handleUpdateNlpSetting(action: UpdateNlpSettingAction) {
  try {
    const datasourceId = yield select(
      (state: AppState) => (selectSpaceInfoItem(state) as IDataSourceInfo).id
    );
    yield call(DataSources.setNlpSetting, {
      id: datasourceId,
      nlpOption: action.nlpSetting,
      askDataFeedbackToCuratorEnabled: action.feedbackToCurator,
    });

    yield put(setNlpSetting(action.nlpSetting, action.feedbackToCurator));
    yield put(updateNlpSettingSucceeded());
  } catch(e) {
    // When there is an error during api call, the current behaviour in Angular is to do nothing
    // We are porting the same behaviour here
    // eslint-disable-next-line no-console
    console.error(e);
  }
}
